<template>
  <div>
    <Breadcrumb >
      <BreadcrumbItem>首页</BreadcrumbItem>
      <BreadcrumbItem>账户管理</BreadcrumbItem>
      <BreadcrumbItem>账户列表</BreadcrumbItem>
    </Breadcrumb>
    <div class="single-page ivu-article">
      <Card >
        <p slot="title">
          <Icon type="ios-list-outline"></Icon>
          账户列表
          <Input >
          <Button slot="append" icon="ios-search"></Button>
          </Input>
        </p>
        <Button type="primary" slot="extra" @click="createUser">
          <Icon type="ios-paperplane"></Icon>
          添加账户
        </Button>
        <div>
          <Form ref="formValidate" inline>
            <FormItem>
              <Input v-model.trim="keyword" clearable @on-enter="search(1)">
                <span slot="prepend">账户名或姓名</span>
              </Input>
            </FormItem>
            <FormItem>
              <Select v-model="searchCcpit" style="width: 150px" :clearable="true" placeholder="是否关联CCPIT官网">
                <Option :value="1">已关联</Option>
                <Option :value="0">未关联</Option>
              </Select>
            </FormItem>
            <FormItem>
              <Button type="primary" @click="search(1)">搜索</Button>
            </FormItem>
          </Form>
        </div>
        <Table :columns="columns" :data="rows" :show-header="true"></Table>
        <Page :total="totalCount" :page-size="pageSize" :current.sync="currentPage" show-total show-elevator @on-change="handlePageChange" style="margin-top: 10px; text-align: right" />
      </Card>
    </div>
    <Modal
        v-model="showModal"
        :title="user.id ? '编辑账户' : '添加账户'"
        :mask-closable="false"
        :loading="modalLoading"
        @on-ok="handleOK()"
        :styles="{top: '10px'}"
        width="500"
    >
      <Form ref="formValidate" label-position="left" :label-width="100" :model="user" :rules="userRules" style="padding: 15px">
        <FormItem label="账户名" prop="name">
          <Input v-model.trim="user.name" ></Input>
        </FormItem>
        <FormItem label="姓名" prop="nickname">
          <Input v-model.trim="user.nickname" ></Input>
        </FormItem>
        <FormItem label="所在单位" prop="orgId">
<!--          <Select v-model="user.orgId" placeholder="如选项中无所在单位，请在机构设置中添加">
            <Option v-for="org in orgList" :key="org.id"
                    :value="org.id">{{ org.orgName }}</Option>
          </Select>-->
          <Poptip v-model="treePopVisible" class="demo-tree-pop" placement="bottom-start">
            <Input v-model="selectOrgName" placeholder="如选项中无所在单位，请在机构设置中添加"></Input>
            <div slot="content">
              <Tree class="org-tree-select" style="width: 100%;" :data="data6" @on-select-change="handleCheckChange"></Tree>
            </div>
          </Poptip>

        </FormItem>
        <FormItem  label="手机号" prop="mobile">
          <Input v-model.trim="user.mobile" ></Input>
        </FormItem>
        <FormItem label="关联CCPIT官网">
          <RadioGroup v-model="user.auditByCcpit">
            <Radio :label="1">关联</Radio>
            <Radio :label="0">不关联</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="参会人查看范围">
          <Select v-model="selectedRole" clearable placeholder="不选择时只能查看本人发布活动的参会人">
            <Option v-for="role in roleList" :key="role.id" :value="role.name">{{ role.note }}</Option>
          </Select>
        </FormItem>
        <FormItem v-if="!user.id" label="密码"  key="create-pwd" prop="pwd"
                  :rules="{required: true, message: '请输入密码（6~20位数字，字母）'}">
          <Input v-model.trim="user.pwd"></Input>
          <div class="text-gr">6~20位字母或者数字</div>
        </FormItem>

        <FormItem v-if="user.id" label="重置密码为（不填写表示不重置密码）" key="update-pwd" >
          <Input v-model.trim="newPwd" ></Input>
        </FormItem>
      </Form>
    </Modal>

    <Modal
        v-model="showBindDptModal"
        title="绑定大平台账户"
        :mask-closable="false"
        :loading="dptModalLoading"
        @on-ok="handleBindDptOK()"
        :styles="{top: '10px'}"
        width="500"
    >
      <Form ref="dptFormValidate" label-position="left" :label-width="100" :model="dptUser" :rules="bindDptRules" style="padding: 15px">
        <FormItem label="大平台用户id" prop="dptUserId">
          <Input v-model.trim="dptUser.dptUserId" ></Input>
        </FormItem>
        <FormItem label="大平台用户机构id" prop="dptOrgId">
          <Input v-model.trim="dptUser.dptOrgId" ></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>

import Vue from 'vue'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  name: 'UserList',
  data () {
    return {
      totalCount: 0,
      pageSize: 10,
      currentPage: 1,
      remoteStatus: null,
      showModal: false,
      modalLoading: true,
      showBindDptModal: false,
      dptModalLoading: true,
      userList: [],
      orgList: [],
      roleList: [],
      selectedRole: null,
      user: {},
      dptUser: {},
      newPwd: null,
      keyword: '',
      searchCcpit: null,
      treePopVisible: false,
      selectOrgName: null,
      data6: [
        {
          title: '全部机构',
          expand: true,
          children: []
        }
      ],
      userRules: {
        name: [
          {required: true, message: '请输入账户名'}
        ],
        nickname: [
          {required: true, message: '请输入人员姓名'}
        ],
        orgId: [
          {required: true, message: '请选择所在单位'}
        ],
        mobile: [
          {required: false, message: '请输入手机号'}
        ]
      },
      bindDptRules: {
        dptUserId: [
          {required: true, message: '请输入大平台用户id'}
        ],
        dptOrgId: [
          {required: true, message: '请输入大平台用户机构id'}
        ]
      },
      columns: [
        {
          title: '账户名',
          key: 'name'
        },
        {
          title: '姓名',
          key: 'nickname'
        },
        {
          title: '单位',
          key: 'orgName'
        },
        {
          title: '创建时间',
          key: 'createDate',
          render: (h, params) => {
            return h('span', this.formatDate(params.row.createDate))
          }
        },
        {
          title: '关联CCPIT官网',
          key: 'auditByCcpit',
          render: (h, params) => {
            return h('span', params.row.auditByCcpit === 1 ? '已关联' : '未关联')
          }
        },
        {
          title: '参会人查看范围',
          key: 'roleNames',
          render: (h, params) => {
            return h('span', this.roleText(params.row.roleNames))
          }
        },
        {
          title: '操作',
          key: 'operation',
          render: (h, params) => {
            let elements = []
            elements.push(
              h('p', [h('Button', {
                props: {
                  type: 'primary',
                  ghost: true,
                  size: 'small'
                },
                style: {'margin': '0 5px 5px 0'},
                on: {
                  click: () => {
                    this.updateUser(params.row)
                  }
                }
              }, '修改信息'),
              h('Button', {
                props: {
                  type: 'primary',
                  ghost: true,
                  size: 'small'
                },
                style: {'margin': '0 5px 5px 0'},
                on: {
                  click: () => {
                    this.getDptUser(params.row)
                  }
                }
              }, params.row.dptUser ? '更新大平台用户' : '绑定大平台用户'),
              h('Button', {
                props: {
                  type: 'success',
                  ghost: true,
                  size: 'small'
                },
                style: {'display': params.row.disabled ? 'inline-block' : 'none', 'margin': '0 5px 5px 0'},
                on: {
                  click: () => {
                    this.enableUser(params.row)
                  }
                }
              }, '启用'),
              h('Button', {
                props: {
                  type: 'error',
                  ghost: true,
                  size: 'small'
                },
                style: {'display': !params.row.disabled ? 'inline-block' : 'none', 'margin': '0 5px 5px 0'},
                on: {
                  click: () => {
                    this.disableUser(params.row)
                  }
                }
              }, '禁用')])
            )

            return h('div', elements)
          }
        }
      ]
    }
  },
  computed: {
    ...mapState({
      loginUser: 'user'
    }),
    rows () {
      return this.userList
    },
    attendeeRoleNames () {
      return this.selectedRole ? [this.selectedRole] : []
    }
  },
  methods: {
    getResultText (result) {
      if (result) {
        return result
      } else {
        return '已发送'
      }
    },
    getTypeText (type) {
      if (type === 'SIGN_ADUIT_PASS') {
        return '审核报名通过'
      } else if (type === 'SIGN_ADUIT_REFUSE') {
        return '审核报名拒绝'
      } else if (type === 'EMAIL_TYPE_NOTIFICATION') {
        return '参会提醒'
      } else {
        return type
      }
    },
    formatDate (timestamp) {
      if (timestamp) {
        return moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
      } else {
        return null
      }
    },
    roleText (roleNames) {
      let roleName = this.resolveSelectedRole(roleNames)
      if (!roleName) {
        return '本人发布活动的参会人'
      }
      let matchedRoles = this.roleList.filter((role) => role.name === roleName)
      return matchedRoles.length > 0 ? matchedRoles[0].note : roleName
    },
    // 单选，存在多个参会人查看范围角色时取范围最大的一个（优先级由后端 /api/admin/roles 返回顺序决定）
    resolveSelectedRole (roleNames) {
      let names = roleNames || []
      for (let role of this.roleList) {
        if (names.indexOf(role.name) !== -1) {
          return role.name
        }
      }
      return null
    },
    // 点击树形获取该行
    handleCheckChange (val) {
      let self = this
      if (val.nodeKey === 0) {
        self.selectOrgName = val[0].title
        Vue.set(self.user, 'orgId', null)
      } else {
        self.selectOrgName = val[0].title
        Vue.set(self.user, 'orgId', val[0].id)
      }
      self.treePopVisible = false
    },
    createUser () {
      this.user = {}
      this.$refs['formValidate'].resetFields()
      this.user = {pwd: 'Password01', auditByCcpit: 0}
      this.selectedRole = null
      this.selectOrgName = null
      this.showModal = true
    },
    updateUser (user) {
      this.user = JSON.parse(JSON.stringify(user))
      this.selectedRole = this.resolveSelectedRole(user.roleNames)
      if (user.orgId) {
        this.selectOrgName = user.orgName
      } else {
        this.selectOrgName = null
      }
      this.user.pwd = null
      this.showModal = true
    },
    getDptUser (user) {
      let userObject = JSON.parse(JSON.stringify(user))
      if (userObject.dptUser && userObject.dptUser.id != null) {
        this.dptUser = userObject.dptUser
      } else {
        Vue.set(this.dptUser, 'localAdminUserId', userObject.id)
        Vue.set(this.dptUser, 'dptUserId', null)
        Vue.set(this.dptUser, 'dptOrgId', null)
      }
      this.showBindDptModal = true
      this.$refs['dptFormValidate'].resetFields()
    },
    enableUser (user) {
      this.$Modal.confirm({
        title: `确认启用用户【${user.name}】？`,
        okText: '确认',
        cancelText: '取消',
        onOk: async () => {
          let updatedUser = (await this.$http.put(`/api/admin/users/${user.id}/enable`)).body
          let matchedIndex = -1
          this.userList.forEach((item, index) => {
            if (item.id === user.id) {
              matchedIndex = index
            }
          })
          if (matchedIndex !== -1) {
            this.userList.splice(matchedIndex, 1, updatedUser)
          }
        }
      })
    },
    disableUser (user) {
      this.$Modal.confirm({
        title: `确认禁用用户【${user.name}】？`,
        okText: '确认',
        cancelText: '取消',
        onOk: async () => {
          let updatedUser = (await this.$http.put(`/api/admin/users/${user.id}/disable`)).body
          let matchedIndex = -1
          this.userList.forEach((item, index) => {
            if (item.id === user.id) {
              matchedIndex = index
            }
          })
          if (matchedIndex !== -1) {
            this.userList.splice(matchedIndex, 1, updatedUser)
          }
        }
      })
    },
    getUpdateUser () {
      this.user.pwd = this.newPwd
      this.user.roleNames = this.attendeeRoleNames
      return this.user
    },
    beforeSave () {
      this.$Message.destroy()
      this.$Loading.start()
    },
    afterSave (e) {
      this.$Loading.finish()
      if (e) {
        this.$Message.error({
          content: e.body.error || '操作失败，请重试',
          duration: 0,
          closable: true
        })
      } else {
        this.$Message.success('操作成功！')
      }
    },
    handlePageChange () {
      this.search(this.currentPage)
    },
    async search (startPage) {
      try {
        this.$Loading.start()
        let queryStr = `page=${startPage}&keyword=${this.keyword ? this.keyword : ''}`
        if (this.searchCcpit === 0 || this.searchCcpit === 1) {
          queryStr += `&searchCcpit=${this.searchCcpit}`
        }
        let resp = await this.$http.get(`/api/admin/users?${queryStr}`)
        this.userList = resp.body.content
        this.remoteStatus = resp.status
        this.totalCount = resp.body.totalElements
        this.totalPage = resp.body.totalPages
        this.$Loading.finish()
      } catch (e) {
        this.afterSave(e)
      }
    },
    async handleOK () {
      let validPass = false
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          validPass = true
        } else {
          validPass = false
        }
      })

      if (!validPass) {
        this.modalLoading = false
        this.$nextTick(() => {
          this.modalLoading = true
        })
        return
      }

      try {
        this.beforeSave()
        if (this.user.id) {
          let updatedUser = (await this.$http.put(`/api/admin/users/${this.user.id}`, this.getUpdateUser())).body
          let matchedIndex = -1
          this.userList.forEach((item, index) => {
            if (item.id === this.user.id) {
              matchedIndex = index
            }
          })
          if (matchedIndex !== -1) {
            this.userList.splice(matchedIndex, 1, updatedUser)
          }
        } else {
          this.user.roleNames = this.attendeeRoleNames
          let createdUser = (await this.$http.post(`/api/admin/users`, this.user)).body
          this.userList.splice(0, 0, createdUser)
        }
        this.afterSave()
      } catch (e) {
        this.afterSave(e)
      }

      this.showModal = false
    },
    async handleBindDptOK () {
      let validPass = false
      this.$refs['dptFormValidate'].validate((valid) => {
        if (valid) {
          validPass = true
        } else {
          validPass = false
        }
      })

      if (!validPass) {
        this.dptModalLoading = false
        this.$nextTick(() => {
          this.dptModalLoading = true
        })
        return
      }

      try {
        this.beforeSave()
        let updatedUser = (await this.$http.post(`/api/admin/users/${this.dptUser.localAdminUserId}/bindDptUser`, this.dptUser)).body
        let matchedIndex = -1
        this.userList.forEach((item, index) => {
          if (item.id === this.dptUser.localAdminUserId) {
            matchedIndex = index
          }
        })
        if (matchedIndex !== -1) {
          this.userList.splice(matchedIndex, 1, updatedUser)
        }
        this.afterSave()
      } catch (e) {
        this.afterSave(e)
      }

      this.showBindDptModal = false
    }
  },
  async beforeRouteEnter (to, from, next) {
    try {
      let resp = await Vue.http.get('/api/admin/users')
      let orgResp = await Vue.http.get('/api/admin/org/all')
      let orgTreeResp = await Vue.http.get('/api/admin/org/treeList')
      let roleResp = await Vue.http.get('/api/admin/roles')

      next(vm => {
        vm.remoteStatus = resp.status
        vm.userList = resp.body.content
        vm.orgList = orgResp.body
        vm.data6[0].children = orgTreeResp.body
        vm.roleList = roleResp.body
        vm.totalCount = resp.body.totalElements
        vm.totalPage = resp.body.totalPages
      })
    } catch (e) {
      next(vm => {
        vm.remoteStatus = e.status
        vm.userList = []
        vm.orgList = []
        vm.roleList = []
        vm.data6.children = []
      })
    }
  },
  async beforeRouteUpdate (to, from, next) {
    try {
      let resp = await Vue.http.get(`/api/admin/users`)
      let orgResp = await Vue.http.get('/api/admin/org/all')
      let orgTreeResp = await Vue.http.get('/api/admin/org/treeList')
      let roleResp = await Vue.http.get('/api/admin/roles')

      this.userList = resp.body.content
      this.orgList = orgResp.body
      this.data6[0].children = orgTreeResp.body
      this.roleList = roleResp.body
      this.remoteStatus = resp.status
      this.totalCount = resp.body.totalElements
      this.totalPage = resp.body.totalPages
      next()
    } catch (e) {
      this.remoteStatus = e.status
      this.userList = []
      this.orgList = []
      this.roleList = []
      this.data6.children = []
      next()
    }
  }
}
</script>

<style scoped="scope" scss>
.demo-tree-pop {
  width: 100%;
}
/deep/ .demo-tree-pop .ivu-poptip-rel {
  width: 100%;
}

.org-tree-select {
  max-height: 500px;
  overflow: auto;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/account/UserList.vue